import { OrderFormat as e } from "@ancon/wildcat-types";
function o(r) {
  return r ? r.find(
    (t) => (t.orderFormats & e.Delivery) === e.Delivery
  ) : null;
}
export {
  o as default
};
